role = function (id, cui_enabled) {

	var objRole = {};
	var objDialog = dialog();
	var objCommittee = committee();
	var objDom = dom(cui_enabled);

	var apSelectParticipants = 0;
	var APStepsWithRoles = '';
	var proposalSelectParticipants = 0;
	var ProposalStepswithRoles = '';
	var proposalNames = '';
	var apNames = '';
	var replacements = '';
	var proposalStepReplacements = '';
	var apRemoveParticipants = 0;
	var proposalRemoveParticipants = 0;
	var committeeIcon = '<img class="entity-role-committee" src="/images/icons/flat/committees.png">';
	var apEditmodeOriginal = [];
	var apEditmodeEditing = [];


	$('#growls').notify();


	objRole.createRoleList = function(roles) {
		// Remove default behaviors
		if ($('#entity-roles .none').length > 0) {
			$('#entity-roles .none').remove();
		}

		// Clean list out to reset it
		$('#entity-roles').contents().remove();

		if (roles.length > 0) {
			$(roles).each(function(index, role) {
				//First, determine if this is a legitimate parent request
				if (role.name === '') {
					role.name = $('#entity-roles-available option:selected').text();
				}

				newRole = $('#role-clone').clone().removeAttr('id');
				var roleIndex = $('#entity-roles li').length;
				$(newRole).children('input').each(function() {
					var theField = '';
					$(this).attr('name',function(i2, val) {
						// role object has id, name, roleTypeID and committee
						theField = role[val];
						return 'role['+roleIndex+']['+val+']';
					}).val(theField);
				});

				$(newRole).append(role.name);

				if (role.committee !== undefined && role.committee.length !== 0) {
					$(newRole).append('<img class="entity-role-committee tip" src="/images/icons/flat/committees.png" title="'+role.committee.name +'">');
				}
				$('#entity-roles').append(newRole);
				objRole.manageRolesSelect();
			});

			$('#entity-roles li').find('img.tip').qtip({content: {text: false}, style: {tip: true}});

		} else {
			$('#entity-roles').append('<li class="no-roles">No roles selected</li>');
		}
	};

	/*
		updateRoleForm is called when a user clicks "edit" on a created role.
		It allows them to edit the name of a role, but blocks the ability to change the role type and committee
	*/

	objRole.updateRoleForm = function(role) {
		$('#entity-role-id').val(role.id);
		$('#entity-role-name').val(role.name);
		$('#committee-dropdown').val(role.committeeID);
		$('#role-type-dropdown').val(role.roleType);
		$('#entity-role-original-committee').val(role.committeeID);

		$('#entity-role-add span').text('Update');
		$('#entity-role-add').attr('id', 'entity-role-edit');

		app.flyout.manageRoles.currentRoleID = role.id;
		$('#role-type-dropdown').attr('disabled', true);
		$('#committee-dropdown').attr('disabled', true);
	};

	objRole.updateRole = function(role, callback) {

		// Get roles into array
		var roles = [];

		$.validity.start();
		$('#entity-role-name').require();
		var result = $.validity.end();

		// Perform insert here
		var postData = {
			role:role
		};

		if (result.valid) {
			$.ajax({
				url: '/admin/entity:' + $('#entity-details-id').val() + '/saveRoles.json',
				type: 'PUT',
				data: postData,
				success: function(data) {
					callback && callback(data);
				}
			});
		}

	};

	objRole.viewRoles = function(id) {
		$('#' + id).toggleClass('active');
	};

	objRole.manageRolesSelect = function() {
		// reset selected
		$('#entity-roles-available').find('option:selected').removeAttr('selected');

		//read through list of currently added items and disable role types that have already been added
		if ($('#entity-roles li').length > 0) {
			$('#entity-roles-available option:not(.no-roles-msg)').removeAttr('disabled');
			$('#entity-roles li input[name$="[roleTypeID]"]').each(function() {
				var type = $(this).val();
				$('#entity-roles-available option').each(function() {
					if ($(this).val() === type) {
						$(this).attr('disabled',true);
					}
				});
			});
		} else {
			//There are either:
			// 1.) No role types (someone removed all of them)
			// 2.) No roles have been added to this entity yet
			// Make sure all options are enabled (if any) and the list of items says "Nothing Selected"
			$('#entity-roles').append('<li class="no-roles">No Roles Selected</li>');
			$('#entity-roles-available option').removeAttr('disabled');
			if ($('#role-types .curriculog-types-current-type').length === 0 &&
						$('#entity-roles-available option:first').val() !== '') {
				$('#entity-roles-available').attr('disabled',true);
				$('<option value="" selected="selected">No Role Types Defined</option>').insertBefore('#entity-roles-available option:first');
			}
		}
		$('#entity-role-name').val('');
		//If ALL items have been added, add option: Nothing Available
		disabledRolesCount = $('#entity-roles-available option:disabled').length;
		rolesCount = $('#entity-roles-available option').length;

		if (disabledRolesCount === rolesCount) {
			$('#entity-roles-available').attr('disabled', true);
			$('#entity-roles-available option[value=""]').remove();
			$('<option value="" selected="selected" disabled class="no-roles-msg">No More Role Types Available</option>').insertBefore('#entity-roles-available option:first');
			$('.entity-role-add').addClass('disabled').attr('disabled', true);
		} else {
			//Set the selected option on the first item that is NOT disabled
			$('#entity-roles-available').removeAttr('disabled');
			$('#entity-roles-available option[value=""]').remove();
			$('#entity-roles-available').val($('#entity-roles-available option:not(:disabled):first').attr('selected','selected'));
			$('.entity-role-add').removeClass('disabled').attr('disabled', false);

			var value = $('#entity-roles-available').val();
			if ($('#entity-roles-available option[value="' + value + '"]').hasClass('role-committee')) {
				$('#entity-role-committee').removeAttr('disabled');
			} else {
				$('#entity-role-committee').attr('disabled', true);
			}
		}

	};


	objRole.destroy = function(obj, callback) {
		var roleID = obj.id;
		var role = app.roles.get(roleID);
		var committeeID = role.get('committee_id');
		var roleTypeID = role.get('role_type_id');

		new Curriculog.DeleteDialog({
			itemType: 'role',
			itemName: role.getSanitizedModel().get('name'),
			callback: function () {
				role.destroy({
					wait: true,

					success: function () {
						if (app.roles.getRolesByCommittee(committeeID).length === 0) {
							var committee = app.committees.get(committeeID);
							committee.set('canDelete', true);
						}

						app.roles.trigger('delete-role');
						var roleType = app.roleTypes.get(roleTypeID);
						roleType.fetch();
					},

					error: function () {
						var text = 'An error was encountered when deleting the role.  ';
						text += 'The role has not been deleted.  Please try again '
						text += 'or contact an administrator.';
						$('#growls').notify('create', 'warning-template', {
							text: text
						});
					},
				});
			},
		});
	};

	return objRole;
};
